import clsx from 'clsx';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { Button, Modal } from '../../../_custom';
import LoadingSpinner from '../../../_custom/LoadingSpinner/LoadingSpinner';
import toolbarStyles from '../PlateToolbar/PlateToolbar.module.scss';
import { IMPORT_ACCEPT } from './importFormats';
import { IMPORT_COPY, IMPORT_PHASE, type ImportPhase } from './constants';
import { useImportDocxLogic } from './useImportDocxLogic';
import styles from './ImportDocxButton.module.scss';

export { applyImportedFragment, stampMissingCellIds } from './importFragment';

function ImportModeModal({
    open,
    phase,
    onReplace,
    onAppend,
    onCancel,
}: {
    open: boolean;
    phase: ImportPhase;
    onReplace: () => void;
    onAppend: () => void;
    onCancel: () => void;
}) {
    const busy = phase === IMPORT_PHASE.READING || phase === IMPORT_PHASE.APPLYING;
    return (
        <Modal open={open} onClose={busy ? () => undefined : onCancel} size="flexible" withoutCloseButton className={styles.OverDrawer}>
            <div className={styles.ImportModeModal}>
                {busy ? (
                    <div className={styles.Status} data-testid="import-status">
                        <LoadingSpinner height="2.5rem" color="var(--primary-text-colour)" />
                        <p className={styles.Subtitle}>{phase === IMPORT_PHASE.READING ? IMPORT_COPY.READING : IMPORT_COPY.APPLYING}</p>
                    </div>
                ) : (
                    <>
                        <div className={styles.Title}>{IMPORT_COPY.TITLE}</div>
                        <div className={styles.Subtitle}>{IMPORT_COPY.SUBTITLE}</div>
                        <div className={styles.Actions}>
                            <Button
                                text={IMPORT_COPY.CANCEL}
                                type="button"
                                onClick={onCancel}
                                variant="purpleinverted"
                                className={styles.ActionButton}
                            />
                            <Button
                                text={IMPORT_COPY.APPEND}
                                type="button"
                                onClick={onAppend}
                                variant="purpleinverted"
                                className={styles.ActionButton}
                            />
                            <Button
                                text={IMPORT_COPY.REPLACE}
                                type="button"
                                onClick={onReplace}
                                variant="primary"
                                className={styles.ActionButton}
                            />
                        </div>
                    </>
                )}
            </div>
        </Modal>
    );
}

export function ImportDocxButton() {
    const { inputRef, phase, busy, onClick, onFile, handleReplace, handleAppend, handleCancel } = useImportDocxLogic();

    return (
        <>
            <button
                type="button"
                className={clsx(toolbarStyles.btn)}
                onMouseDown={onClick}
                disabled={busy}
                aria-busy={busy}
                title={IMPORT_COPY.TITLE_ATTR}
                aria-label={IMPORT_COPY.ARIA}
            >
                {busy ? (
                    <LoadingSpinner height="0.875rem" color="var(--primary-text-colour)" />
                ) : (
                    <FileUploadOutlinedIcon fontSize="small" />
                )}{' '}
                {IMPORT_COPY.BUTTON}
            </button>
            <input ref={inputRef} type="file" accept={IMPORT_ACCEPT} onChange={onFile} className={styles.FileInput} />
            <ImportModeModal
                open={phase !== IMPORT_PHASE.IDLE}
                phase={phase}
                onReplace={handleReplace}
                onAppend={handleAppend}
                onCancel={handleCancel}
            />
        </>
    );
}
